module.exports = __webpack_public_path__ + "media/images/icons/icon_round_two_blue-118133d8cf18c8a8d15a133fd45f8568.svg";